// const DEFAULT_AUTH_URL = "https://launchpad.classlink.com/oauth2/v2/auth";
const DEFAULT_AUTH_URL = "https://launchpad.classlink.com/oauth2/v2/auth";
const DEFAULT_REDIRECT_PATH = "/sso/classlink/callback";
const DEFAULT_SCOPE = "profile email";
const DEFAULT_GRANT_TYPE = "google_sso";

const STORAGE_PREFIX = "isafe_classlink";
export const CLASSLINK_STATE_STORAGE_KEY = `${STORAGE_PREFIX}_oauth_state`;

export const getClassLinkClientId = () =>
  process.env.REACT_APP_CLASSLINK_CLIENT_ID || "";

export const getInternalSSOClientId = () =>
  process.env.REACT_APP_ISAFE_SSO_CLIENT_ID;

export const getInternalSSOClientSecret = () =>
  process.env.REACT_APP_ISAFE_SSO_CLIENT_SECRET;

export const getClassLinkScope = () =>
  process.env.REACT_APP_CLASSLINK_SCOPE || DEFAULT_SCOPE;

export const getClassLinkGrantType = () => DEFAULT_GRANT_TYPE;

export const getClassLinkRedirectUri = () => {
  const envRedirect = process.env.REACT_APP_CLASSLINK_REDIRECT_URI;
  if (envRedirect) {
    return envRedirect;
  }

  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}${DEFAULT_REDIRECT_PATH}`;
  }
  return DEFAULT_REDIRECT_PATH;
};

export const getClassLinkAuthUrl = (state) => {
  const clientId = getClassLinkClientId();
  const redirectUri = getClassLinkRedirectUri();
  const scope = getClassLinkScope();
  const authBase =
    process.env.REACT_APP_CLASSLINK_AUTH_URL || DEFAULT_AUTH_URL;

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    redirect_uri: redirectUri,
    scope,
    state,
  });

   console.log(`${authBase}?${params.toString()}`)
  return `${authBase}?${params.toString()}`;
};

export const storeClassLinkState = (state) => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.setItem(CLASSLINK_STATE_STORAGE_KEY, state);
  } catch (error) {
    console.warn("Unable to persist ClassLink state", error);
  }
};

export const readClassLinkState = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return "";
  }

  try {
    return window.sessionStorage.getItem(CLASSLINK_STATE_STORAGE_KEY) || "";
  } catch (error) {
    console.warn("Unable to read ClassLink state", error);
    return "";
  }
};

export const clearClassLinkState = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.removeItem(CLASSLINK_STATE_STORAGE_KEY);
  } catch (error) {
    console.warn("Unable to clear ClassLink state", error);
  }
};
